import { parsePhoneNumberFromString, formatIncompletePhoneNumber } from 'libphonenumber-js';

export function formatPhoneNumber(phoneNumber: string): string {
  const parsed = parsePhoneNumberFromString(phoneNumber, 'BR');
  if (parsed) {
    return parsed.formatNational();
  }
  return phoneNumber;
}

export function normalizePhoneInput(input: string): string {
  const digits = input.replace(/\D/g, '');

  // Garante prefixo do Brasil e limita a 13 dígitos (55 + DDD + 9)
  const withCountry = digits.startsWith('55') ? digits : `55${digits}`;
  const limited = withCountry.slice(0, 13);

  return formatIncompletePhoneNumber(`+${limited}`, 'BR');
}

export function validatePhone(phoneNumber: string): boolean {
  const parsed = parsePhoneNumberFromString(phoneNumber, 'BR');
  return parsed ? parsed.isValid() : false;
}
